import { Dialog } from "@base-ui-components/react/dialog";
import { X } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import type { LinkView } from "../api";

interface QrDialogProps {
  link: LinkView | null;
  onClose: () => void;
}

export function QrDialog({ link, onClose }: QrDialogProps) {
  const url = link?.originalUrl ?? "";

  return (
    <Dialog.Root open={Boolean(link)} onOpenChange={(nextOpen) => (nextOpen ? undefined : onClose())}>
      <Dialog.Portal>
        <Dialog.Backdrop className="dialog-backdrop" />
        <Dialog.Viewport className="dialog-viewport">
          <Dialog.Popup className="dialog-popup max-w-sm">
            <div className="dialog-header">
              <div>
                <Dialog.Title className="dialog-title">Subscription QR</Dialog.Title>
                <Dialog.Description className="dialog-description">{link?.name ?? "Subscription URL"}</Dialog.Description>
              </div>
              <Dialog.Close className="dialog-close" aria-label="Close">
                <X aria-hidden="true" className="h-4 w-4" />
              </Dialog.Close>
            </div>

            {url ? (
              <div className="mt-5 grid justify-items-center gap-4">
                <div className="rounded-md bg-white p-3">
                  <QRCodeSVG
                    value={url}
                    size={224}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="M"
                    marginSize={2}
                  />
                </div>
                <p className="w-full break-all rounded-md border border-[#24201b] bg-[#111316] px-3 py-2 text-xs leading-5 text-[#d8d0c8] [overflow-wrap:anywhere]">
                  {url}
                </p>
                <Dialog.Close className="accent-button w-full sm:w-auto">Close</Dialog.Close>
              </div>
            ) : null}
          </Dialog.Popup>
        </Dialog.Viewport>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
